import { Box , styled} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import {InputBase} from '@mui/material'
import React, { useState } from 'react'
import { useChatContex } from '../../../contex/ChatContex';





const Components=styled(Box)`
background:#fff;
height:45px;
border-bottom:1px solid #F2F2F2;
display:flex;
align-items:center;

`

const Wrapper=styled(Box)`
background-color:#f0f2f5;
position:relative;
margin:0 13px;
width:100%;
border-radius:10px;


`
const Icon=styled(Box)`
position:absolute;
height:100%;
padding:6px 10px;
color:#919191;

`
const InputField=styled(InputBase)`
width:100%;
padding:16px;
height:15px;
padding-left:65px;
font-size:14px
`







function Search({setSearch}) {

    

    

const{filterUser,SetSearch}=useChatContex()



    return (
        <Components>
           <Wrapper>
           <Icon>
                 <SearchIcon
                    fontSize='small'
                 />
            </Icon>
            <InputField
                 placeholder="Search or start new chat"
                 inputProps={{ 'aria-label': 'search' }}
                 onChange={(e)=>setSearch(e.target.value)}
            />
           </Wrapper>
        </Components>
    )
}

export default Search
